module.exports = "/_next/static/images/phone-1x-6567b234902d61586c02480493b4e17b.png.webp";